import React, { Suspense } from "react";
import {BrowserRouter} from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store,persistor  } from "./redux/store";
import PublicRoutes from "./routes/routes";
import { Spin } from "antd";
import AppLayout from "./components/appLayout";
const App = () => {
  // get token from pingID
  const valueTokenUrl = window.location.href;
  if (valueTokenUrl?.split('access_token=')[1] !== undefined) {
    localStorage.setItem('pingAccessToken', valueTokenUrl?.split('access_token=')[1]);
  }
  return (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={<div className="loader"><Spin /></div>}>
            <PublicRoutes/>
          </Suspense>
      </PersistGate>
    </Provider>
  );
};

export default App;
